<template>
  <div :style="{height: `${height}px`}">
    <legacy
      v-if="legacy"
      :color="color"
      :dark="dark"
      :id="id"
      :size="size"
      :timejump="timejump"
    />
    <player
      v-if="!playlist && !legacy && !recast"
      :color="color"
      :dark="dark"
      :height="height"
      :id="id"
      :timejump="timejump"
      :websocket="websocketPath"
    />
    <playlist
      v-if="playlist"
      :color="color"
      :dark="dark"
      :height="height"
      :id="id"
      :websocket="websocketPath"
    />
    <recast
      v-if="recast"
      :id="id"
      :websocket="websocketPath"
    />
  </div>
</template>

<script>
import Legacy from '../src/components/Legacy.vue'
import Player from '../src/components/Player.vue'
import Playlist from '../src/components/Playlist.vue'
import Recast from '../src/components/Recast.vue'

export default {
  components: {
    Legacy,
    Player,
    Playlist,
    Recast
  },
  props: {
    websocket: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      color: '',
      dark: false,
      id: '',
      episode: {},
      height: this.getHeight(),
      hex: this.color,
      legacy: false,
      playlist: false,
      podcast: {},
      recast: false,
      size: 'small',
      timejump: 0
    }
  },
  computed: {
    websocketPath () {
      if (process.env.WEBSOCKET_PATH && process.env.WEBSOCKET_PATH !== '') return process.env.WEBSOCKET_PATH

      return this.websocket
    }
  },
  created () {
    const pathSplit = window.location.pathname.trim('/').replace(/^\/+|\/+$/gm, '').split('/')

    this.color = window.location.hash !== '' ? window.location.hash : window.getUrlParameter('color') || ''
    this.dark = window.getUrlParameter('dark') === 'true'
    this.id = pathSplit[0] !== 'recast' ? pathSplit[0] : pathSplit[1]
    this.legacy = window.getUrlParameter('legacy')
    this.playlist = window.getUrlParameter('show')
    this.timejump = this.getTimeJump()

    this.recast = pathSplit[0] === 'recast'

    if (window.getUrlParameter('size')) this.size = window.getUrlParameter('size')

    window.addEventListener('resize', this.setHeight)
    window.addEventListener('hashchange', this.setColor)
  },
  methods: {
    getHeight () {
      return window.innerHeight
    },
    getTimeJump () {
      if (!window.getUrlParameter('t')) return 0

      const t = window.getUrlParameter('t')
      const re = /^(?:(?:(\d+)[:|h])?(\d\d?)[:|m])?(\d\d?)[.\d+]?/i
      const [all, hours, minutes, seconds] = t.match(re)
      let total = 0

      console.log(all)

      // Hours to seconds
      if (hours) total = parseInt(hours) * 3600
      if (minutes) total += parseInt(minutes) * 60
      if (seconds) total += parseInt(seconds)

      return total
    },
    setColor () {
      this.color = window.location.hash
    },
    setHeight () {
      this.height = this.getHeight()
    }
  }
}
</script>

<style lang="scss">
body, html {
  margin: 0;
  padding: 0;
  overflow: hidden;
}
</style>
